export const ItemTypes = {
  FAM: "fam",
  CM: "cm",
  Module: "module",
};
